enum TOKENTRANSFERS_STATES {
  idle = "idle",
  loading = "loading",
  success = "success",
  failure = "failure",
}

export { TOKENTRANSFERS_STATES };
